// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/datapipelines/v1/data_pipelines.proto" (package "viam.app.datapipelines.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { TabularDataSourceType } from "../../data/v1/data";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message viam.app.datapipelines.v1.DataPipeline
 */
export interface DataPipeline {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The associated Viam organization ID.
     *
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * A unique identifier at the org level.
     *
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * A MongoDB aggregation pipeline as a list of BSON documents, where
     * each document is one stage in the pipeline.
     *
     * @generated from protobuf field: repeated bytes mql_binary = 4;
     */
    mqlBinary: Uint8Array[];
    /**
     * A cron expression representing the expected execution schedule in UTC (note this also
     * defines the input time window; an hourly schedule would process 1 hour of data at a time).
     *
     * @generated from protobuf field: string schedule = 5;
     */
    schedule: string;
    /**
     * Whether or not the pipeline is enabled.
     *
     * @generated from protobuf field: bool enabled = 6;
     */
    enabled: boolean;
    /**
     * The time the pipeline was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 7;
     */
    createdOn?: Timestamp;
    /**
     * The time the pipeline was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8;
     */
    updatedAt?: Timestamp;
    /**
     * The type of data source for the pipeline. If not specified, default is standard data storage.
     *
     * @generated from protobuf field: optional viam.app.data.v1.TabularDataSourceType data_source_type = 9;
     */
    dataSourceType?: TabularDataSourceType;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.GetDataPipelineRequest
 */
export interface GetDataPipelineRequest {
    /**
     * The ID of the data pipeline to retrieve.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.GetDataPipelineResponse
 */
export interface GetDataPipelineResponse {
    /**
     * @generated from protobuf field: viam.app.datapipelines.v1.DataPipeline data_pipeline = 1;
     */
    dataPipeline?: DataPipeline;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.ListDataPipelinesRequest
 */
export interface ListDataPipelinesRequest {
    /**
     * The associated Viam organization ID.
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.ListDataPipelinesResponse
 */
export interface ListDataPipelinesResponse {
    /**
     * @generated from protobuf field: repeated viam.app.datapipelines.v1.DataPipeline data_pipelines = 1;
     */
    dataPipelines: DataPipeline[];
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.CreateDataPipelineRequest
 */
export interface CreateDataPipelineRequest {
    /**
     * The associated Viam organization ID.
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * A unique identifier at the org level.
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * A MongoDB aggregation pipeline as a list of BSON documents, where
     * each document is one stage in the pipeline.
     *
     * @generated from protobuf field: repeated bytes mql_binary = 3;
     */
    mqlBinary: Uint8Array[];
    /**
     * A cron expression representing the expected execution schedule in UTC (note this also
     * defines the input time window; an hourly schedule would process 1 hour of data at a time).
     *
     * @generated from protobuf field: string schedule = 4;
     */
    schedule: string;
    /**
     * When true, pipeline runs will be scheduled for the organization's past data.
     *
     * @generated from protobuf field: optional bool enable_backfill = 5;
     */
    enableBackfill?: boolean;
    /**
     * The type of data source for the pipeline. If not specified, default is standard data storage.
     *
     * @generated from protobuf field: optional viam.app.data.v1.TabularDataSourceType data_source_type = 6;
     */
    dataSourceType?: TabularDataSourceType;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.CreateDataPipelineResponse
 */
export interface CreateDataPipelineResponse {
    /**
     * The ID of the newly created data pipeline.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.RenameDataPipelineRequest
 */
export interface RenameDataPipelineRequest {
    /**
     * The ID of the data pipeline to rename.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * A unique identifier at the organization level.
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.RenameDataPipelineResponse
 */
export interface RenameDataPipelineResponse {
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.DeleteDataPipelineRequest
 */
export interface DeleteDataPipelineRequest {
    /**
     * The ID of the data pipeline to delete.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.DeleteDataPipelineResponse
 */
export interface DeleteDataPipelineResponse {
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.EnableDataPipelineRequest
 */
export interface EnableDataPipelineRequest {
    /**
     * The ID of the data pipeline to enable.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.EnableDataPipelineResponse
 */
export interface EnableDataPipelineResponse {
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.DisableDataPipelineRequest
 */
export interface DisableDataPipelineRequest {
    /**
     * The ID of the data pipeline to disable.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.DisableDataPipelineResponse
 */
export interface DisableDataPipelineResponse {
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.ListDataPipelineRunsRequest
 */
export interface ListDataPipelineRunsRequest {
    /**
     * The ID of the data pipeline to list runs for.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * pagination fields
     *
     * @generated from protobuf field: uint32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.ListDataPipelineRunsResponse
 */
export interface ListDataPipelineRunsResponse {
    /**
     * The ID of the data pipeline the runs are for.
     *
     * @generated from protobuf field: string pipeline_id = 1;
     */
    pipelineId: string;
    /**
     * The runs that were run.
     *
     * @generated from protobuf field: repeated viam.app.datapipelines.v1.DataPipelineRun runs = 2;
     */
    runs: DataPipelineRun[];
    /**
     * A token to retrieve the next page of results.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message viam.app.datapipelines.v1.DataPipelineRun
 */
export interface DataPipelineRun {
    /**
     * The ID of the run.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The time the run started.
     *
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 2;
     */
    startTime?: Timestamp;
    /**
     * The time the run ended.
     *
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 3;
     */
    endTime?: Timestamp;
    /**
     * The start time of the data that was processed in the run.
     *
     * @generated from protobuf field: google.protobuf.Timestamp data_start_time = 4;
     */
    dataStartTime?: Timestamp;
    /**
     * The end time of the data that was processed in the run.
     *
     * @generated from protobuf field: google.protobuf.Timestamp data_end_time = 5;
     */
    dataEndTime?: Timestamp;
    /**
     * The status of the run.
     *
     * @generated from protobuf field: viam.app.datapipelines.v1.DataPipelineRunStatus status = 6;
     */
    status: DataPipelineRunStatus;
    /**
     * The error message if the run failed.
     *
     * @generated from protobuf field: string error_message = 7;
     */
    errorMessage: string;
    /**
     * The data source type the run executed against. Runs that predate this field
     * report the pipeline's configured data source type.
     *
     * @generated from protobuf field: viam.app.data.v1.TabularDataSourceType data_source_type = 8;
     */
    dataSourceType: TabularDataSourceType;
}
/**
 * @generated from protobuf enum viam.app.datapipelines.v1.DataPipelineRunStatus
 */
export enum DataPipelineRunStatus {
    /**
     * @generated from protobuf enum value: DATA_PIPELINE_RUN_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DATA_PIPELINE_RUN_STATUS_SCHEDULED = 1;
     */
    SCHEDULED = 1,
    /**
     * @generated from protobuf enum value: DATA_PIPELINE_RUN_STATUS_STARTED = 2;
     */
    STARTED = 2,
    /**
     * @generated from protobuf enum value: DATA_PIPELINE_RUN_STATUS_COMPLETED = 3;
     */
    COMPLETED = 3,
    /**
     * @generated from protobuf enum value: DATA_PIPELINE_RUN_STATUS_FAILED = 4;
     */
    FAILED = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class DataPipeline$Type extends MessageType<DataPipeline> {
    constructor() {
        super("viam.app.datapipelines.v1.DataPipeline", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mql_binary", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ },
            { no: 5, name: "schedule", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "data_source_type", kind: "enum", opt: true, T: () => ["viam.app.data.v1.TabularDataSourceType", TabularDataSourceType, "TABULAR_DATA_SOURCE_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.DataPipeline
 */
export const DataPipeline = new DataPipeline$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDataPipelineRequest$Type extends MessageType<GetDataPipelineRequest> {
    constructor() {
        super("viam.app.datapipelines.v1.GetDataPipelineRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.GetDataPipelineRequest
 */
export const GetDataPipelineRequest = new GetDataPipelineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDataPipelineResponse$Type extends MessageType<GetDataPipelineResponse> {
    constructor() {
        super("viam.app.datapipelines.v1.GetDataPipelineResponse", [
            { no: 1, name: "data_pipeline", kind: "message", T: () => DataPipeline }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.GetDataPipelineResponse
 */
export const GetDataPipelineResponse = new GetDataPipelineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDataPipelinesRequest$Type extends MessageType<ListDataPipelinesRequest> {
    constructor() {
        super("viam.app.datapipelines.v1.ListDataPipelinesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.ListDataPipelinesRequest
 */
export const ListDataPipelinesRequest = new ListDataPipelinesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDataPipelinesResponse$Type extends MessageType<ListDataPipelinesResponse> {
    constructor() {
        super("viam.app.datapipelines.v1.ListDataPipelinesResponse", [
            { no: 1, name: "data_pipelines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataPipeline }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.ListDataPipelinesResponse
 */
export const ListDataPipelinesResponse = new ListDataPipelinesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDataPipelineRequest$Type extends MessageType<CreateDataPipelineRequest> {
    constructor() {
        super("viam.app.datapipelines.v1.CreateDataPipelineRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "mql_binary", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "schedule", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "enable_backfill", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "data_source_type", kind: "enum", opt: true, T: () => ["viam.app.data.v1.TabularDataSourceType", TabularDataSourceType, "TABULAR_DATA_SOURCE_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.CreateDataPipelineRequest
 */
export const CreateDataPipelineRequest = new CreateDataPipelineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDataPipelineResponse$Type extends MessageType<CreateDataPipelineResponse> {
    constructor() {
        super("viam.app.datapipelines.v1.CreateDataPipelineResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.CreateDataPipelineResponse
 */
export const CreateDataPipelineResponse = new CreateDataPipelineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameDataPipelineRequest$Type extends MessageType<RenameDataPipelineRequest> {
    constructor() {
        super("viam.app.datapipelines.v1.RenameDataPipelineRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.RenameDataPipelineRequest
 */
export const RenameDataPipelineRequest = new RenameDataPipelineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameDataPipelineResponse$Type extends MessageType<RenameDataPipelineResponse> {
    constructor() {
        super("viam.app.datapipelines.v1.RenameDataPipelineResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.RenameDataPipelineResponse
 */
export const RenameDataPipelineResponse = new RenameDataPipelineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDataPipelineRequest$Type extends MessageType<DeleteDataPipelineRequest> {
    constructor() {
        super("viam.app.datapipelines.v1.DeleteDataPipelineRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.DeleteDataPipelineRequest
 */
export const DeleteDataPipelineRequest = new DeleteDataPipelineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDataPipelineResponse$Type extends MessageType<DeleteDataPipelineResponse> {
    constructor() {
        super("viam.app.datapipelines.v1.DeleteDataPipelineResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.DeleteDataPipelineResponse
 */
export const DeleteDataPipelineResponse = new DeleteDataPipelineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableDataPipelineRequest$Type extends MessageType<EnableDataPipelineRequest> {
    constructor() {
        super("viam.app.datapipelines.v1.EnableDataPipelineRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.EnableDataPipelineRequest
 */
export const EnableDataPipelineRequest = new EnableDataPipelineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableDataPipelineResponse$Type extends MessageType<EnableDataPipelineResponse> {
    constructor() {
        super("viam.app.datapipelines.v1.EnableDataPipelineResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.EnableDataPipelineResponse
 */
export const EnableDataPipelineResponse = new EnableDataPipelineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableDataPipelineRequest$Type extends MessageType<DisableDataPipelineRequest> {
    constructor() {
        super("viam.app.datapipelines.v1.DisableDataPipelineRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.DisableDataPipelineRequest
 */
export const DisableDataPipelineRequest = new DisableDataPipelineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableDataPipelineResponse$Type extends MessageType<DisableDataPipelineResponse> {
    constructor() {
        super("viam.app.datapipelines.v1.DisableDataPipelineResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.DisableDataPipelineResponse
 */
export const DisableDataPipelineResponse = new DisableDataPipelineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDataPipelineRunsRequest$Type extends MessageType<ListDataPipelineRunsRequest> {
    constructor() {
        super("viam.app.datapipelines.v1.ListDataPipelineRunsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.ListDataPipelineRunsRequest
 */
export const ListDataPipelineRunsRequest = new ListDataPipelineRunsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDataPipelineRunsResponse$Type extends MessageType<ListDataPipelineRunsResponse> {
    constructor() {
        super("viam.app.datapipelines.v1.ListDataPipelineRunsResponse", [
            { no: 1, name: "pipeline_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "runs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataPipelineRun },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.ListDataPipelineRunsResponse
 */
export const ListDataPipelineRunsResponse = new ListDataPipelineRunsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataPipelineRun$Type extends MessageType<DataPipelineRun> {
    constructor() {
        super("viam.app.datapipelines.v1.DataPipelineRun", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 4, name: "data_start_time", kind: "message", T: () => Timestamp },
            { no: 5, name: "data_end_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "status", kind: "enum", T: () => ["viam.app.datapipelines.v1.DataPipelineRunStatus", DataPipelineRunStatus, "DATA_PIPELINE_RUN_STATUS_"] },
            { no: 7, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "data_source_type", kind: "enum", T: () => ["viam.app.data.v1.TabularDataSourceType", TabularDataSourceType, "TABULAR_DATA_SOURCE_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datapipelines.v1.DataPipelineRun
 */
export const DataPipelineRun = new DataPipelineRun$Type();
/**
 * @generated ServiceType for protobuf service viam.app.datapipelines.v1.DataPipelinesService
 */
export const DataPipelinesService = new ServiceType("viam.app.datapipelines.v1.DataPipelinesService", [
    { name: "GetDataPipeline", options: {}, I: GetDataPipelineRequest, O: GetDataPipelineResponse },
    { name: "ListDataPipelines", options: {}, I: ListDataPipelinesRequest, O: ListDataPipelinesResponse },
    { name: "CreateDataPipeline", options: {}, I: CreateDataPipelineRequest, O: CreateDataPipelineResponse },
    { name: "RenameDataPipeline", options: {}, I: RenameDataPipelineRequest, O: RenameDataPipelineResponse },
    { name: "DeleteDataPipeline", options: {}, I: DeleteDataPipelineRequest, O: DeleteDataPipelineResponse },
    { name: "EnableDataPipeline", options: {}, I: EnableDataPipelineRequest, O: EnableDataPipelineResponse },
    { name: "DisableDataPipeline", options: {}, I: DisableDataPipelineRequest, O: DisableDataPipelineResponse },
    { name: "ListDataPipelineRuns", options: {}, I: ListDataPipelineRunsRequest, O: ListDataPipelineRunsResponse }
]);
